export function parsedUrlType(string) {
  if (/\s/.test(string)) {
    return 'text';
  }
  try {
    return urlType(new URL(string));
  } catch (exception) {
    return 'text';
  }
}

function urlType(url) {
  if (url.protocol === 'http:' || url.protocol === 'https:') {
    return httpUrlType(url);
  }
  return 'text';
}

function httpUrlType(url) {
  if (url.host.indexOf('..') > -1) {
    return 'text';
  }
  return /\.(jpe?g|png|gif)$/.test(url.pathname) ? 'image' : 'link';
}
